import React from 'react';
import { observable } from 'mobx';
import AcompanhamentoProcessoService from '../../../services/AcompanhamentoProcessoService';
import desovaPierService from "../../../services/DesovaPierService";
import {
    formatarInfoAvaria, formatarInfoPerigoso, montarSelectOption,
    formatarDataCustomHTML, formatarReal, formatarDivergenciaLacre,
    formatarLink
} from '../../../utils/formatar';
import { buscaFiltrarVazio, buscaSemResultado } from '../../../utils/mensagens';
import { normalizarString } from '../../../utils/functions';
import { sortCaret } from '../../comum/components/Icones';
import lscache from 'lscache';
import moment from 'moment';
import { urlApi } from '../../../config/Constantes';

export default class AcompanhamentoStore {

    @observable alerta;
    @observable informacao;
    @observable documento;
    @observable avariaExpandido;
    @observable detalhesCntrExpandido;
    @observable nfExpandido;
    @observable arquivosExpandido;

    @observable tipoAcompanhamento;
    @observable consolidado;
    @observable mostrarInfo
    @observable carregando;

    @observable listaProcessos;
    @observable listaAnexosDesova;
    @observable colunasCntr;

    @observable dadosContainers;
    @observable dadosProcesso;
    @observable dadosSituacao;
    @observable dadosNF;
    @observable dadosTimeline;
    @observable dadosVesselVisit;

    @observable dadosAverbacao;
    @observable processoAverbado;

    @observable showModalDesistencia;
    @observable showModalAverbacao;
    @observable showModalVesselVisit;
    @observable mensagemErro;
    @observable mensagemErroAverbacao;
    @observable mensagemModalAverbacao;
    @observable mensagemModalBLValido;
    @observable desistenciaMensagem;
    @observable desistencia;
    @observable divergenciaLacre;
    @observable processo;
    @observable despachante;
    @observable naviosCE;
    @observable solicitaNavio;

    @observable navioSelecionado;
    @observable despachanteSelecionado;
    @observable tipoProcessoSelecionado;
    @observable atualizaDados;

    @observable BLValidoAverbacao;
    @observable dadosAverbacao
    @observable processoAverbado

    @observable showModalDesistencia
    @observable showModalAverbacao
    @observable showModalArquivos
    @observable mensagemErro
    @observable mensagemErroAverbacao
    @observable mensagemModalAverbacao
    @observable mensagemModalArquivos
    @observable desistenciaMensagem
    @observable desistencia
    @observable divergenciaLacre
    @observable cargaAvariada
    @observable processo
    @observable despachante
    @observable naviosCE
    @observable solicitaNavio

    @observable navioSelecionado
    @observable despachanteSelecionado
    @observable tipoProcessoSelecionado
    @observable atualizaDados
    @observable desovaId;


    constructor() {

        this.documento = ""
        this.tipoAcompanhamento = ""
        this.consolidado = ""
        this.mensagemErro = ""
        this.mensagemErroAverbacao = ""
        this.mensagemModalAverbacao = "";
        this.mensagemModalArquivops = "";
        this.mensagemModalBLValido = "";
        this.desistenciaMensagem = "";

        this.alerta = false;
        this.informacao = true;
        this.avariaExpandido = false;

        this.detalhesCntrExpandido = false;
        this.nfExpandido = false;

        this.arquivosExpandido = false;
        this.desovaId = 0;

        this.mostrarInfo = false;
        this.carregando = false;
        this.desistencia = false;
        this.divergenciaLacre = null;
        this.cargaAvariada = null;

        this.showModalDesistencia = false
        this.showModalAverbacao = false;
        this.showModalArquivos = false;
        this.showModalVesselVisit = false;

        this.listaProcessos = []
        this.listaDespachanteUsuario = []
        this.colunasCntr = []
        this.listaAnexosDesova = []

        this.dadosContainers = null
        this.dadosProcesso = null
        this.dadosSituacao = null;
        this.dadosTimeline = null;
        this.dadosVesselvisit = null;
        this.dadosNF = null
        this.dadosAverbacao = {
            TipoProcessoId: null,
            Bl: null,
            Di: null,
            Deacordo: null,
            DspId: null
        }
        this.processoAverbado = false;

        this.naviosCE = [];
        this.solicitaNavio = false;
        this.navioSelecionado = {};
        this.despachanteSelecionado = {};
        this.tipoProcessoSelecionado = {};
        this.atualizaDados = true;

        this.BLValidoAverbacao = null;

        this.timeLineModal = process.env.rig ? [normalizarString("Averbação").toUpperCase(),
        normalizarString("Agendamento").toUpperCase()] :
            [normalizarString("Liberação Documental").toUpperCase(),
            normalizarString("Solicitação de Serviços").toUpperCase(),
            normalizarString("Estimativa de Calculo").toUpperCase(),
            normalizarString("Faturamento").toUpperCase()];

        this.acompService = new AcompanhamentoProcessoService();

        this.download = document.createElement('a');
        document.body.appendChild(this.download);
        this.download.style = "display: none";
        this.download.target = "_blank";

        this.loadingDownloadRelatorio = false;

        this.abrirAverbacao = this.abrirAverbacao.bind(this);
    }

    abrirFecharDetalhe = (detalhe) => {
        switch (detalhe) {
            case 'avaria':
                this.avariaExpandido = !this.avariaExpandido
                break
            case 'detalheContainer':
                this.detalhesCntrExpandido = !this.detalhesCntrExpandido
                break
            case 'notaFiscal':
                this.nfExpandido = !this.nfExpandido
                break
            case 'arquivos':
                this.arquivosExpandido = !this.arquivosExpandido;
                break;
            default:
                return
        }
    }

    abrirDesistencia = () => {
        this.showModalDesistencia = true
    }

    fecharDesistencia = () => {
        this.showModalDesistencia = false
    }

    abrirAverbacao = () => {
        if (this.BLValidoAverbacao)
            this.showModalAverbacao = true
        else
            this.mensagemModalBLValido = "Não foi possível averbar, favor entrar em contato com o escritório de importação!";
    }


    abrirModalVesselVisit = () => {
        this.showModalVesselVisit = true
    }

    fecharModalVesselVisit = () => {
        this.showModalVesselVisit = false
    }

    fecharAverbacao = () => {
        if (!this.processoAverbado) {
            this.limparDadosAverbacao();
        }
        this.showModalAverbacao = false;
    }

    salvarArquivos = async () => {
        const anexosResponse = await this.salvarAnexos(this.listaAnexosDesova, this.dadosProcesso.DocId);
        console.log(anexosResponse);
        this.showModalArquivos = false;
    }

    salvarAnexos = async (anexos, document) => {
        return await Promise.all(anexos.map(async (arquivo) => {
            if(arquivo.Id !== 0) return arquivo;
            let arqv = new FormData()
            arqv.append('file', arquivo.file);

            const response = await desovaPierService.salvarAnexo(arqv, arquivo.Extensao, arquivo.Nome, null, document)

            if (response && response.data) {
                if (response.data.Sucesso) {
                    arquivo.Id = response.data.Id
                    return arquivo
                } else {
                    Promise.reject(response.data.Mensagem || response.data.MensagemErro);
                }
            }
        }))
    };


    removerAnexo = async (id, index) => {
        if (id !== 0) {
            try {
                const response = await desovaPierService.deletarAnexo(id);
                if (!response.data) {
                    this.mensagemErro = 'Erro ao apagar. Tente novamente.'
                    console.log(response);
                    return;
                }
                this.listaAnexosDesova.splice(index, 1);
            } catch (error) {
                this.controller.mensagemErro = 'Erro ao apagar. Tente novamente.';
                console.log(error);
                return;
            }
        } else {
            this.listaAnexosDesova.splice(index, 1);
        }
    }

    anexarArquivo = (arquivo) => {
        if (this.mensagemErro !== "") this.mensagemErro = ""
        Array.from(arquivo.target.files).map((arqv, index) => {
            let filename = arqv.name.replace(/[^a-zA-Z0-9\.]/g, "");
            filename = filename.split('.')[0];
            if (typeof (this.listaAnexosDesova) === 'undefined') {
                this.listaAnexosDesova = [];
            }
            console.log({ Id: 0, file: arqv, Nome: filename, Extensao: arqv.name.split('.').pop() });
            this.listaAnexosDesova.push({ Id: 0, file: arqv, Nome: filename, Extensao: arqv.name.split('.').pop() });
        })
    }


    baixarAnexo = (id, index) => {
        if (!id) {
            const anexo = this.listaAnexosDesova[index];
            const file = new File([this.listaAnexosDesova[index].file], `${anexo.Nome}.${anexo.Extensao}`, { type: 'application/octet-stream' })
            this.gerarLinkDownload(file, anexo)
        } else {
            const anexo = this.listaAnexosDesova.find(anexo => anexo.Id === id)
            
            fetch(`${urlApi}/SolicitacaoDesovaPier/baixar-arquivo?idArquivo=${id}`).then(res => {
                if (res.status !== 200) {
                    this.mensagemErro = "Não foi possível completar o download";
                } else {
                    return res.blob();
                }
            }).then(blob => 
                this.gerarLinkDownload(blob, anexo)
            ).catch(err => { 
                console.error(err); 
                this.mensagemErro = "Erro ao fazer o download" 
            })
        }
    }

    gerarLinkDownload = (file, anexo) => {
        const url = window.URL.createObjectURL(file)
        this.download.href = url
        this.download.download = `${anexo.Nome}.${anexo.Extensao}`
        this.download.click()
        window.URL.revokeObjectURL(url)
    }

    abrirModalArquivos = () => {
        this.loadingArquivos = true;

        desovaPierService.obterAnexosDesovaPorDocId(this.dadosProcesso.DocId).then(
            res => {
                if (res && res.data) {
                        console.log(res.data)
                        this.listaAnexosDesova = res.data;
                        this.showModalArquivos = true;
                    } else {
                        this.mensagemErro = "Não foi possível completar a busca de arquivos";
                    }
            }).catch(err => { console.error(err); this.mensagemErro = "Erro ao buscar arquivos da desova" }
            ).finally(() => {
                this.loadingArquivos = false;
            });
    }

  


    baixarRelatorioPresenca = () => {

        this.loadingDownloadRelatorio = true;
        fetch(`${urlApi}/AcompanhamentoProcesso/Relatorio?numeroBl=${this.documento}`).then(res => {
            if (res.status !== 200) {
                this.mensagemErro = "Não foi possível completar o download";
            } else {
                return res.blob();
            }
        }).then(blob => {
            const url = window.URL.createObjectURL(blob)
            this.download.href = url
            this.download.download = `relatorio.pdf`
            this.download.click()
            window.URL.revokeObjectURL(url)
        }).catch(err => { console.error(err); this.mensagemErro = "Erro ao fazer o download" }
        ).finally(() => {
            this.loadingDownloadRelatorio = false;
        });

    }

    baixarRelatorioDetalhado = () => {

        this.loadingDownloadRelatorio = true;
        fetch(`${urlApi}/AcompanhamentoProcesso/RelatorioDetalhado?documento=${this.documento}&vesselVisitId=${this.dadosProcesso.VesselVisit}`).then(res => {
            if (res.status !== 200) {
                this.mensagemErro = "Não foi possível completar o download";
            } else {
                return res.blob();
            }
        }).then(blob => {
            const url = window.URL.createObjectURL(blob)
            this.download.href = url
            this.download.download = `relatorio.pdf`
            this.download.click()
            window.URL.revokeObjectURL(url)
        }).catch(err => { console.error(err); this.mensagemErro = "Erro ao fazer o download" }
        ).finally(() => {
            this.loadingDownloadRelatorio = false;
        });

    }

    limparDadosAverbacao = () => {
        this.dadosAverbacao.TipoProcessoId = null;
        this.dadosAverbacao.Bl = null;
        this.dadosAverbacao.Di = null;
        this.dadosAverbacao.Deacordo = null;
        this.dadosAverbacao.DspId = null;

        this.processoAverbado = false;
        this.despachanteSelecionado = {};
        this.tipoProcessoSelecionado = {};
    }

    listarProcessos = async () => {
        try {
            let response = await this.acompService.ListarTipoProcesso();
            if (response && response.data) {
                this.listaProcessos = await montarSelectOption("Id.CdTipo", "DscTipo", response.data);
                if (this.dadosAverbacao.TipoProcessoId) {
                    this.listaProcessos.map(process => {
                        if (process.value === this.dadosAverbacao.TipoProcessoId) {
                            this.setTipoProcesso(process);
                        }
                    });
                }
            }
        }
        catch (err) {
            console.log("listarProcessos: ", err);
        }
    }

    desistirVistoria = () => {
        this.acompService.DesistirVistoria(this.dadosProcesso.DocId).then(response => {
            if (response.data.Sucesso) {
                this.desistenciaMensagem = "Desistência realizada com sucesso.";
                this.desistencia = true
            } else {
                this.desistenciaMensagem = "Erro na desistência.";
            }
        }).catch(err => console.log(err))
    }

    listarDespachantePorUsuario = async () => {
        try {
            let response = await this.acompService.ListarDespachantePorUsuario();
            if (response && response.data) {
                if (!this.processoAverbado) {
                    this.listaDespachanteUsuario = await montarSelectOption("Valuefield", "Textfield", response.data);
                }
            }
        }
        catch (err) {
            console.log("listarDespachantePorUsuario: ", err);
        }
    }

    filtrar = () => {
        this.listarDados()
    }

    setPesquisaLink = (bool) => {
        lscache.set('acompProcesso-pesquisa-doc', bool, 5);
    }

    setNavio = (valor) => {
        if (valor) {
            this.navioSelecionado = valor;
        }
    };

    setDespachanteAverbacao = (valor) => {
        if (valor) {
            this.despachanteSelecionado = valor;
        }
    };

    setTipoProcesso = (valor) => {
        if (valor) {
            this.tipoProcessoSelecionado = valor;
        }
    };

    listarDados = async () => {
        try {
            this.atualizaDados = false;
            this.carregando = true;
            this.avariaExpandido = false;
            if (!this.navioSelecionado.value) {
                this.colunasCntr = [];
                this.mensagemErro = "";
                this.navioSelecionado = {};
                this.solicitaNavio = false;
                if (this.documento === "") {
                    this.mensagemErro = buscaFiltrarVazio
                    this.carregando = false
                    this.atualizaDados = true;
                    return
                }
            }
            let response = await this.acompService.ListarProcessos(!this.navioSelecionado.value ? this.documento : this.navioSelecionado.value);
            if (response.data.Processo) {
                if (!this.navioSelecionado.value) {
                    const getCte = response.data.Processo.Documento;
                    try {

                        let res = await this.acompService.ListarNavioPorCe(getCte);
                        if (res.data && res.data.length > 1) {
                            this.naviosCE = res.data;
                            this.navioSelecionado = {};
                            this.navioSelecionado.label = res.data[0].Navio;
                            this.navioSelecionado.value = res.data[0].Ce;
                            this.solicitaNavio = true;

                            lscache.set('acompProcesso-navio', this.navioSelecionado, 5);

                            //Eliminando dados da consulta anterior
                            this.tipoAcompanhamento = "";
                            this.dadosProcesso = null;
                            this.dadosSituacao = null;

                            this.desistencia = false;
                            this.divergenciaLacre = null;
                            this.cargaAvariada = null;
                            this.dadosContainers = null;
                            this.dadosTimeline = null;
                            this.dadosVesselVisit = null;
                            this.dadosNF = null;

                            this.mostrarInfo = false;
                            this.alerta = false;
                            this.informacao = true;
                            this.atualizaDados = true;

                            this.limparDadosAverbacao();
                            return
                        }
                    }
                    catch (error) {
                        console.log(error);
                    }

                }
                this.consolidado = response.data.Processo.IndConsolidado;
                this.tipoAcompanhamento = response.data.Processo.Tipo;
                this.dadosProcesso = response.data.Processo;

                let dataAtual = moment();

                this.BLValidoAverbacao = process.env.rig ?
                    this.dadosProcesso.DataCriacao ?
                        (dataAtual.diff(this.dadosProcesso.DataCriacao, 'days') <= 90)
                        : false
                    : true;

                this.dadosSituacao = response.data.Situacao;

                this.desistencia = response.data.Processo.FlagDesistVistoria === "V" ? true : false;
                this.divergenciaLacre = response.data.Processo.FlagDivergLacre === "V" ? true : false;
                this.cargaAvariada = response.data.Processo.FlagAvaria === "V" ? true : false;
                this.dadosContainers = response.data.ListaContainers;
                this.dadosTimeline = response.data.ListaTimeline;
                this.dadosVesselVisit = response.data.VesselVisit;

                lscache.flushExpired();
                if (response.data.Processo.Documento) {

                    lscache.set('acompProcesso-doc', response.data.Processo.Documento, 5);

                    if (process.env.ssa && response.data.Processo.Tipo === "C") {
                        // SSA: Cabotagem
                        lscache.set('acompProcesso-cabotagem-doc', response.data.Processo.Documento, 5);
                    } else if (process.env.ssa && response.data.Processo.Tipo === "I") {
                        //SSA: Importacao
                        lscache.set('acompProcesso-importacao-doc', response.data.Processo.Documento, 5);
                    }
                }

                this.dadosContainers.map((cntr, index) => {
                    cntr.ExisteAvaria = cntr.Avaria !== null ? "S" : "N"
                    cntr.Id = cntr.UnitId
                });

                this.dadosTimeline.map(time => {
                    time.Normalizado = normalizarString(time.Estagio).toUpperCase();
                    time.icon = null;
                    time.voltar = "";
                    time.terminalVisibility = [];
                });

                this.colunasCntr = this.colunasDetalhesCntr
                if (response.data.Processo.Tipo === "I") {
                    this.colunasCntr.push({
                        dataField: "Ehperigosa",
                        text: "Perigoso",
                        headerAlign: "center",
                        sortCaret: sortCaret,
                        formatter: formatarInfoPerigoso,
                        sort: true
                    })
                }

                if (response.data.Processo.Tipo === "E")
                    this.colunasCntr = this.colunasDetalhesCntrExport

                if (response.data.Averbacao) {
                    this.dadosAverbacao = response.data.Averbacao;
                    this.processoAverbado = true;
                }
                else {
                    this.limparDadosAverbacao();
                }

                await this.listarDespachantePorUsuario();

                if (process.env.rig) await this.listarProcessos();

                this.dadosTimeline.map(time => {
                    if (this.timeLineModal.includes(time.Normalizado)) {
                        if (process.env.ssa && response.data.Processo.Tipo === "C" && normalizarString("Liberação Documental").toUpperCase() === time.Normalizado) {
                            // SSA: Cabotagem
                            time.link = '/liberacoes-cabotagem';
                            time.voltar = '/acompanhamento-processo';
                            time.terminalVisibility = ["SSA"];
                            time.icon = time.Data ? true : false;
                        } else if (process.env.ssa && response.data.Processo.Tipo === "I" && normalizarString("Liberação Documental").toUpperCase() === time.Normalizado) {
                            //SSA: Importacao
                            time.link = '/liberacoes-importacao';
                            time.voltar = '/acompanhamento-processo';
                            time.terminalVisibility = ["SSA"];
                            time.icon = time.Data ? true : false;
                        } else if (process.env.ssa && normalizarString("Solicitação de Serviços").toUpperCase() === time.Normalizado) {
                            //SSA: Importacao
                            time.link = '/agendamento-servicos';
                            time.voltar = '/acompanhamento-processo';
                            time.terminalVisibility = ["SSA"];
                            time.icon = time.Data ? true : false;
                        } else if (process.env.ssa && normalizarString("Estimativa de Calculo").toUpperCase() === time.Normalizado) {
                            //SSA: Importacao
                            time.link = '/consulta-orcamentos';
                            time.voltar = '/acompanhamento-processo';
                            time.terminalVisibility = ["SSA"];
                            time.icon = time.Data ? true : false;
                        } else if (process.env.ssa && normalizarString("Faturamento").toUpperCase() === time.Normalizado) {
                            //SSA: Importacao
                            time.link = '/faturamento-notafiscal';
                            time.voltar = '/acompanhamento-processo';
                            time.terminalVisibility = ["SSA"];
                            time.icon = time.Data ? true : false;
                        } else if (process.env.rig && normalizarString("Averbação").toUpperCase() === time.Normalizado) {
                            //RIG: Averbação
                            time.link = null;
                            time.voltar = '';
                            time.terminalVisibility = ["RIG"];
                            time.icon = time.Data ? true : false;
                        } else if (process.env.rig && normalizarString("Agendamento").toUpperCase() === time.Normalizado) {
                            //RIG: Agendamento
                            time.link = '/agendamento-container';
                            time.voltar = '/acompanhamento-processo';
                            time.terminalVisibility = ["RIG"];
                            time.icon = time.Data ? true : false;
                        }
                    }
                });

                this.dadosNF = response.data.ListaNf;
                this.mostrarInfo = true;
                this.alerta = true;
                this.informacao = false;
                this.atualizaDados = true;
            } else {
                this.alerta = false;
                this.informacao = true;
                this.mensagemErro = buscaSemResultado;
                this.atualizaDados = true;
            }
        }
        catch (err) {
            console.log(err)
        }
        finally {
            this.atualizaDados = true;
            this.carregando = false;
        }
    }

    fechaAlerta = () => {
        this.alerta = false
    }

    setBlHouse = (value) => {
        console.log(value)
        this.documento = value;
        this.naviosCE = [];
        this.navioSelecionado = {};
        this.solicitaNavio = false;
    }

    salvarAverbacao = () => {
        this.mensagemModalAverbacao = "";
        this.mensagemErroAverbacao = "";
        this.acompService.SalvarAverbacao(this.despachanteSelecionado.value,
            this.tipoProcessoSelecionado.value,
            this.documento,
            this.dadosAverbacao.Di,
            this.dadosAverbacao.Deacordo || "F").then(resp => {
                if (resp.data && resp.data.Sucesso) {
                    this.fecharAverbacao();
                    this.mensagemModalAverbacao = "Sua averbação foi cadastrada com sucesso";
                    this.filtrar();
                } else {
                    this.mensagemErroAverbacao = resp.data.MensagemErro;
                    this.mensagemModalAverbacao = "Houve um problema ao salvar a averbação";
                }
                return true;
            }).catch(err => {
                console.log('err SalvarAverbacao :', err);
                return false;
            })
    }

    onChangeProcesso = value => {
        this.dadosAverbacao.TipoProcessoId = value !== null ? value : false;
    };

    onChangeDespachante = value => {
        this.dadosAverbacao.DspId = value !== null ? value : false;
    };

    onChangeNumeroProcessoDi = value => {
        if (value) {
            this.dadosAverbacao.Di = value.hasOwnProperty('target') ? value.target.value : value;
        }
    };

    colunasArquivos = [

    ];

    colunasAvaria = [
        {
            dataField: "DocId",
            text: "Id",
            hidden: true
        },
        {
            dataField: "Container",
            text: "Containers",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"
        },
        {
            dataField: "LacresAtuais",
            text: "Lacre conferido",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"
        },
        {
            dataField: "LacresManifestados",
            text: "Lacre manifestado",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"
        },
        {
            dataField: "LacresOk",
            text: "Divergência lacre",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "center",
            formatter: formatarDivergenciaLacre
        },
        {
            dataField: "AvariaCarga",
            text: "Avaria Carga",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left",
            hidden: !process.env.rig
        },
        {
            dataField: "ExisteAvaria",
            text: "Avaria",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "center",
            formatter: formatarInfoAvaria,
            hidden: process.env.rig
        },
        {
            dataField: "AvariaCntr",
            text: "Avaria Container",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left",
            hidden: !process.env.rig
        },
        {
            dataField: "MsgAvaria",
            text: "Mensagem",
            sortCaret: sortCaret,
            headerAlign: "left",
            hidden: true
        }
    ]

    colunasDetalhesCntr = [
        {
            dataField: "Container",
            text: "Números",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "DtEntrada",
            text: "Descarga",
            sort: true,
            formatter: formatarDataCustomHTML,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "DtAgend",
            text: "Data/Hora Agendamento",
            formatter: formatarDataCustomHTML,
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left",
            hidden: !process.env.rig
        }, {
            dataField: "DtSaida",
            formatter: formatarDataCustomHTML,
            text: "Saída Container",
            sortCaret: sortCaret,
            sort: true,
            headerAlign: "left"
        }, {
            dataField: "Desovado",
            formatter: formatarInfoAvaria,
            text: "Desovado",
            sortCaret: sortCaret,
            sort: true,
            headerAlign: "center",
            hidden: process.env.rig
        }, {
            dataField: "DtSaidaCarga",
            formatter: formatarDataCustomHTML,
            text: "Saída Carga",
            sortCaret: sortCaret,
            sort: true,
            headerAlign: "left"
        }, {
            dataField: "SituacaoDanfe",
            text: "Status Danfe",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left",
            hidden: !process.env.rig
        }, {
            dataField: "TipoCntr",
            text: "Tipo",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"
        }
    ]

    colunasDetalhesCntrExport = [
        {
            dataField: "Container",
            text: "Números",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "DtEntrada",
            formatter: formatarDataCustomHTML,
            text: "Entrada",
            style: { width: '150px' },
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "DtSaida",
            formatter: formatarDataCustomHTML,
            text: "Saída",
            style: { width: '150px' },
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "FlagDesistencia",
            formatter: (cell) => cell === "S" ? <div className="situacao-btn acomp-processo mb-0" style={{ width: "50px" }}>Sim</div> : "-",
            text: "Desistência",
            style: { width: '150px' },
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left",
        }, {
            dataField: "TipoCntr",
            text: "Tipo",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "CnpjCobrarDe",
            text: "CNPJ de Cobrança",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "StatusSiscarga",
            text: "Status siscarga",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "StatusSiscomex",
            text: "Status Siscomex",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "LacresAtuais",
            text: "Lacres Atuais",
            sort: true,
            hidden: process.env.rig,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "LacresManifestados",
            text: "Lacres Manifestados",
            sort: true,
            hidden: process.env.rig,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "LacresOk",
            text: "Lacres OK",
            sort: true,
            hidden: process.env.rig,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "ChaveNfe",
            text: "Chave da Nota",
            sort: true,
            classes: "chave-nota",
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "NumNotaTransp",
            text: "Número da Nota",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "UltEnvio",
            text: "Data ultimo envio",
            style: { width: '150px' },
            sort: true,
            formatter: formatarDataCustomHTML,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "StatusDueNftcDsc",
            text: "Status Recepção NF",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        }, {
            dataField: "RetornoReceita",
            text: "Retorno Receita",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"
        }
    ]

    colunasNF = [
        {
            dataField: "NumeroNota",
            text: "Número da Nota Fiscal",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left",
            formatter: formatarLink,
            formatExtraData: { link: "/faturamento-notafiscal", voltar: "/acompanhamento-processo" },
        },
        {
            dataField: "DtEmissao",
            formatter: formatarDataCustomHTML,
            text: "Emissão",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: "left"
        },
        {
            dataField: "ValorTotal",
            text: "Valor",
            sort: true,
            formatter: formatarReal,
            sortCaret: sortCaret,
            headerAlign: "left"

        },
        {
            dataField: "Razao",
            text: "Razão social",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        },
        {
            dataField: "Cnpj",
            text: "CNPJ do cliente",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: "left"

        },
    ]
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/stores/AcompanhamentoStore.js